//#region src/components/Calendar/dates.ts
/** Midnight at the start of the day, local time. */
function startOfDay(date) {
	return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}
function startOfMonth(date) {
	return new Date(date.getFullYear(), date.getMonth(), 1);
}
function addDays(date, days) {
	return new Date(date.getFullYear(), date.getMonth(), date.getDate() + days);
}
/** The same day `months` later, clamped to the end of a shorter month (Jan 31 + 1 → Feb 28). */
function addMonths(date, months) {
	const first = new Date(date.getFullYear(), date.getMonth() + months, 1);
	const lastDay = new Date(first.getFullYear(), first.getMonth() + 1, 0).getDate();
	return new Date(first.getFullYear(), first.getMonth(), Math.min(date.getDate(), lastDay));
}
function isSameDay(a, b) {
	return !!a && !!b && a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
}
function isSameMonth(a, b) {
	return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth();
}
/** True if `a` is an earlier day than `b`. */
function isBeforeDay(a, b) {
	return startOfDay(a).getTime() < startOfDay(b).getTime();
}
/** The six weeks shown for `month`, starting on `weekStartsOn` (0 Sunday, 1 Monday). */
function monthGrid(month, weekStartsOn) {
	const first = startOfMonth(month);
	const start = addDays(first, -((first.getDay() - weekStartsOn + 7) % 7));
	return Array.from({ length: 6 }, (_, week) => Array.from({ length: 7 }, (_, day) => addDays(start, week * 7 + day)));
}
/** The first day of the week containing `date`. */
function startOfWeek(date, weekStartsOn) {
	return addDays(date, -((date.getDay() - weekStartsOn + 7) % 7));
}
//#endregion
export { addDays, addMonths, isBeforeDay, isSameDay, isSameMonth, monthGrid, startOfDay, startOfMonth, startOfWeek };

//# sourceMappingURL=dates.js.map